"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "serramazzoni": {
    "520cfdc8": [{
      "hkey": "34bd692c",
      "slug": "varana",
      "name": "Varana",
      "primary": true,
      "skipSearch": false
    }],
    "campodolio": [{
      "hkey": "34bd692c",
      "slug": "varana",
      "name": "Varana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6d0861a2": [{
      "hkey": "2ae87062",
      "slug": "casa-bartolacelli-stella",
      "name": "Casa Bartolacelli-Stella",
      "primary": true,
      "skipSearch": false
    }],
    "casa-stella": [{
      "hkey": "2ae87062",
      "slug": "casa-bartolacelli-stella",
      "name": "Casa Bartolacelli-Stella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6d826549": [{
      "hkey": "3de10f34",
      "slug": "serramazzoni",
      "name": "Serramazzoni",
      "primary": true,
      "skipSearch": false
    }],
    "granarolo": [{
      "hkey": "3de10f34",
      "slug": "serramazzoni",
      "name": "Serramazzoni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;